import { render, staticRenderFns } from "./DataModelIntra.vue?vue&type=template&id=1cc7c2bd&scoped=true"
import script from "./DataModelIntra.vue?vue&type=script&lang=js"
export * from "./DataModelIntra.vue?vue&type=script&lang=js"
import style0 from "./DataModelIntra.vue?vue&type=style&index=0&id=1cc7c2bd&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc7c2bd",
  null
  
)

export default component.exports